import PromotionLetter from "../../../../components/company/workforce/promotion/PromotionLetter";

export default function PromotionLetterPage(){
    return <PromotionLetter />
}